<template>
  <div class="home">
    <el-carousel trigger="click" :height="bannerHeight">
      <el-carousel-item
        v-for="(item, index) in indexJson.bannerRespList"
        :key="index"
        class="cursor"
      >
        <img
          ref="bannerHeight"
          :src="item.filePath"
          style="width: 100%"
          @click="imgLink(item)"
          @load="imgLoad"
        />
      </el-carousel-item>
    </el-carousel>
    <div class="container flex margin-tb-xl">
      <el-card class="message">
        <p
          v-for="(item, index) in messageList"
          :key="index"
          @click="onActive(item, index)"
          :class="activeIndex == index ? 'activep' : ''"
          class="padding-left"
        >
          {{ menuCodes[item.code] }}
        </p>
      </el-card>
      <div class="message-right" style="background: #f9fafb">
        <message-component :type="activeIndex" />
      </div>
    </div>
    <!-- 产业智库 -->
    <div
      style="background: #f6f7f8; padding-bottom: 60px"
      class="padding-top-lg"
      v-show="menuCodes['10002']"
    >
      <div class="container flex">
        <span class="text-bold text-xxl1 lh-sm">{{ menuCodes["10002"] }}</span>
        <el-tabs
          class="margin-left"
          v-model="activeName"
          @tab-click="handleClick"
        >
          <el-tab-pane
            v-for="item in proList"
            :label="menuCodes[item.code]"
            :name="item.key"
            :key="item.key"
            v-show="menuCodes[item.code]"
          >
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="container flex justify-between margin-top-sm">
        <el-card
          v-for="(item, index) in proMessage"
          :key="index"
          class="cursor industry"
          style="width: 279px"
        >
          <div @click="onDetail('industry', 'researchReport', item.researchId)">
            <img :src="item.filePath" style="width: 100%" />
            <p class="text-bold text-df margin-left-xs desc">
              {{ item.title }}
            </p>
            <p class="text-sm text-grey margin-lr-xs desc">
              {{ item.shortDescription }}
            </p>
          </div>
          <el-button
            class="margin-left-xs margin-bottom-sm"
            size="medium"
            @click="onDetail('industry', 'researchReport', item.researchId)"
            >查看详情</el-button
          >
        </el-card>
      </div>
      <span
        v-show="proMessage.length > 0"
        class="more cursor fr margin-top-sm text-df margin-right-xs text-grey"
        @click="
          $router.push(
            activeName == '1'
              ? '/industry/researchReport'
              : '/industry/expertList'
          )
        "
        >查看更多
        <img
          src="@/assets/icon-more.png"
          style="width: 20px; vertical-align: bottom"
          alt=""
      /></span>
    </div>
    <!-- 关于协会 -->
    <div style="background: #ffffff; height: 540px" v-show="menuCodes['10003']">
      <div class="container flex padding-top-lg">
        <span class="text-bold text-xxl1 lh-sm">{{ menuCodes["10003"] }}</span>
        <el-tabs
          class="margin-left"
          v-model="activeKey"
          @tab-click="handleClick"
        >
          <el-tab-pane
            v-for="item in associationList"
            :label="menuCodes[item.code]"
            :name="item.key"
            :key="item.key"
            v-show="menuCodes[item.code]"
          >
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="container margin-top-sm">
        <div v-show="activeKey == 'first'">
          <el-col :span="10">
            <p class="text-lg text-bold">协会简介</p>
            <p class="text-df text-gray lh-sm">
              江苏省物联网服务协会是经江苏省民政厅批准设立、由江苏省通信管理局主管的，具备独立法人资格，省级物联网服务领域的非营利性社团组织。
              目前，已发展近80家会员，包含物联网领域的相关企事业单位、高等院校以及国内知名物联网产业链企业。
            </p>
            <p class="text-lg text-bold">宗旨与使命</p>
            <p class="text-df text-gray lh-sm">
              以“服务企业升级，促进产业繁荣”为宗旨，以“汇聚优势资源，成为最有价值的产业服务平台”为使命，面向物联网服务领域，团结所属会员，协调与政府、社会之间的关系；促进物联网服务领域产学研工作的结合，加强领域内的交流，为促进江苏省物联网服务领域的发展做出贡献。
            </p>
          </el-col>
          <el-col :span="12" class="margin-left">
            <img src="@/assets/img-map.png" alt="" />
            <span
              class="
                more
                cursor
                fr
                margin-top-sm
                text-df
                margin-right-xs
                text-grey
              "
              @click="$router.push('/association/introduction')"
              >查看更多
              <img
                src="@/assets/icon-more.png"
                style="width: 20px; vertical-align: bottom"
                alt=""
            /></span>
          </el-col>
        </div>
        <div v-show="activeKey == 'second'">
          <img src="@/assets/img-orm.png" alt="" />
          <span
            class="more cursor fr text-df margin-right-xs text-grey"
            @click="$router.push('/association/organization')"
            >查看更多
            <img
              src="@/assets/icon-more.png"
              style="width: 20px; vertical-align: bottom"
              alt=""
          /></span>
        </div>
        <div v-show="activeKey == 'third'">
          <el-card
            v-for="(item, index) in ruleList"
            :key="index"
            class="margin-top-xs"
            style="height: 50px; line-height: 50px"
            ><span class="text-bold primary padding-left">·</span>
            <span class="text-gray text-df text-bold">{{ item.title }}</span>
            <span
              class="more cursor fr text-df margin-right-sm text-grey"
              @click="$router.push('/association/regulations')"
              >查看更多>></span
            ></el-card
          >
        </div>
      </div>
    </div>

    <!-- 会员中心 -->
    <div
      style="background: #f6f7f8"
      class="padding-top-lg"
      v-show="menuCodes['10004']"
    >
      <div class="container flex">
        <span class="text-bold text-xxl1 lh-sm">{{ menuCodes["10004"] }}</span>
        <el-tabs
          class="margin-left"
          v-model="activeNo"
          @tab-click="handleClick"
        >
          <el-tab-pane
            v-for="item in vipList"
            :label="menuCodes[item.code]"
            :name="item.key"
            :key="item.key"
            v-show="menuCodes[item.code]"
          >
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="container padding-bottom-lg margin-top-sm">
        <div v-if="activeNo == 'first'">
          <span
            v-for="item in vipMemberList"
            :key="item.infoId"
            class="
              margin-lr-xs
              hover-style
              margin-top-sm
              text-left text-df
              cursor
            "
            style="
              width: 265px;
              color: #252b3a;
              display: inline-block;
              background: #ffffff;
              padding: 5px 0px 5px 15px;
            "
          >
            {{ item.name }}</span
          >
          <span
            class="
              more
              cursor
              fr
              margin-top-sm
              text-df
              margin-right-xs
              text-grey
            "
            @click="$router.push('/memberCenter/vipMember')"
            >查看更多
            <img
              src="@/assets/icon-more.png"
              style="width: 20px; vertical-align: bottom"
              alt=""
          /></span>
        </div>
        <div v-show="activeNo == 'second'">
          <VipTable class="margin-bottom-sm" />
          <span
            class="more cursor fr text-df margin-right-xs text-grey"
            @click="$router.push('/memberCenter/benefits')"
            >查看更多
            <img
              src="@/assets/icon-more.png"
              style="width: 20px; vertical-align: bottom"
              alt=""
          /></span>
        </div>
        <div v-if="activeNo == 'third'">
          <el-carousel
            :autoplay="false"
            trigger="click"
            indicator-position="outside"
            height="340px"
          >
            <el-carousel-item
              v-for="(item, index) in logoList"
              :key="index"
              class="flex justify-between"
            >
              <el-card
                v-for="(t, i) in item"
                :key="'logo' + i"
                style="width: 279px; height: 335px; background: #f9fafb"
                class="car-vip"
              >
                <img
                  style="margin-top: -1px; width: 100%"
                  :src="t.filePath"
                  alt=""
                  @click="onDetail('memberCenter', 'vipDescribe', t.descrId)"
                />
                <div
                  @click="onDetail('memberCenter', 'vipDescribe', t.descrId)"
                >
                  <p class="text-bold text-df margin-left-xs">
                    {{ t.vipName }}
                  </p>
                  <p class="text-sm text-grey margin-lr-xs desc" style="height:32px">
                    {{ t.shortDescription }}
                  </p>
                  <el-button
                    class="margin-left-xs margin-bottom-xs  detail-button"
                    size="medium"
                    @click="onDetail('memberCenter', 'vipDescribe', t.descrId)"
                    >查看详情
                  </el-button>
                </div>
              </el-card>
            </el-carousel-item>
          </el-carousel>
          <p
            class="text-center more-button cursor"
            @click="$router.push('/memberCenter/vipDescribe')"
          >
            查看更多
          </p>
        </div>
      </div>
    </div>
    <!-- 平台服务 -->
    <div>
      <Platform
        :backgroundColor="backgroundColor"
        v-show="menuCodes['10005']"
      />
    </div>
  </div>
</template>

<script>
import MessageComponent from "./components/message.vue";
import VipTable from "./components/vipTable.vue";
import Platform from "./components/platform.vue";
import api from "@/utils/api";
export default {
  name: "Home",
  components: {
    MessageComponent,
    VipTable,
    Platform,
  },
  data() {
    return {
      backgroundColor: "#ffffff",
      bannerHeight: "",
      messageList: [
        {
          title: "通知公告",
          code: "100011",
        },
        {
          title: "协会要闻",
          code: "100012",
        },
        {
          title: "会员动态",
          code: "100013",
        },
        {
          title: "产业动态",
          code: "100014",
        },
      ],
      proList: [
        {
          name: "产业研究报告",
          key: "1",
          code: "100021",
        },
        {
          name: "专家智库名录",
          key: "2",
          code: "100022",
        },
      ],
      associationList: [
        {
          name: "协会简介",
          key: "first",
          code: "100031",
        },
        {
          name: "组织架构",
          key: "second",
          code: "100032",
        },
        {
          name: "规章制度",
          key: "third",
          code: "100033",
        },
      ],
      vipList: [
        {
          name: "会员网络",
          key: "first",
          code: "100041",
        },
        {
          name: "会员权益",
          key: "second",
          code: "100042",
        },
        {
          name: "会员风采",
          key: "third",
          code: "100043",
        },
      ],
      ruleList: [],
      logoList: [],
      proMessage: [],
      vipMemberList: [],
      activeIndex: 0,
      activeName: "1",
      activeKey: "first",
      activeNo: "first",
      indexJson: {},
      bannerArr: [],
    };
  },
  watch: {
    activeName: {
      async handler(val) {
        let res = await api.getResearchReportApi({
          type: val,
          pageNum: 1,
          pageSize: 4,
        });
        if (res.code == 200) {
          this.proMessage = res.data.list;
        }
      },
      immediate: true,
    },
  },
  computed: {
    menuCodes() {
      return this.$store.state.menuCodes;
    },
  },
  mounted() {
    this.imgLoad();
    window.addEventListener("resize", () => {
      if (this.$refs.bannerHeight) {
        this.bannerHeight = this.$refs.bannerHeight[0].height + "px";
      }

      this.imgLoad();
    });
    this.getData();
    this.getInstitute();
    this.getVipMemberk();
    this.getVipDescribe();
  },
  methods: {
    async getData() {
      let res = await api.getIndexContentApi();
      if (res.code == 200) {
        this.indexJson = res.data;
      }
    },
    //获取规章制度
    async getInstitute() {
      let res = await api.getInstituteApi();
      if (res.code == 200) {
        this.ruleList = res.data;
      }
    },
    //获取会员网络
    async getVipMemberk() {
      let res = await api.getVipMemberApi();
      if (res.code == 200) {
        let length = Object.keys(res.data).length;
        if (length == 1) {
          this.vipMemberList = [...res.data[1]];
        } else if (length == 2) {
          this.vipMemberList = [...res.data[1], ...res.data[2]];
        } else {
          this.vipMemberList = [...res.data[1], ...res.data[2], ...res.data[3]];
        }
      }
    },
    //获取会员风采
    async getVipDescribe() {
      let res = await api.getVipDescribeApi({
        pageNum: 1,
        pageSize: 12,
      });
      if (res.code == 200) {
        this.logoList = [
          res.data.list.slice(0, 4),
          res.data.list.slice(4, 8),
          res.data.list.slice(8, 12),
        ];
      }
    },
    //查看详情
    onDetail(path, name, val) {
      if (path == "industry") {
        if (this.activeName == 2) {
          name = "expertList";
        }
      }
      this.$router.push({
        path: `/${path}/detail`,
        query: {
          name: name,
          id: val,
        },
      });
    },
    imgLink(val) {
      if(val.advLink){
        window.open(val.advLink);
      }   
    },
    imgLoad() {
      this.$nextTick(() => {
        if (this.$refs&&this.$refs.bannerHeight) {
          this.bannerHeight = this.$refs.bannerHeight[0].height + "px";
        }
      });
    },
    onActive(val, index) {
      this.activeIndex = index;
    },
    handleClick(val) {
      if (val) {
      }
    },
  },
};
</script>
<style>
.contain-center {
  width: 1200px;
  margin: 0 auto;
  background: #ffff;
}

.el-carousel__item {
  width: 100%;
  height: 100%;
}

.el-carousel__container {
  /* height: 100% !important; */
}
.hover-style:hover {
  background: #aa0000 !important;
  color: #ffffff !important;
}

.product:hover {
  background: #aa0000;
  color: #ffffff !important;
}

.product:hover .desc {
  color: #ffffff !important;
}

.product:hover .el-button {
  background: #aa0000;
  color: #ffffff !important;
}
.industry:hover .el-button {
  background: #aa0000;
  color: #ffffff !important;
}
.product-contain {
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
  flex-wrap: wrap;
  padding-bottom: 15px;
  width: 1100px;
  margin: 0 auto;
}

.product-contain p {
  width: 48%;
  /* font-size: 20px; */
  line-height: 46px;
  color: #18181a;
}

.contain-center .el-col {
  width: 353px;
  height: 370px;
  box-shadow: 0px 7px 25px 0px rgba(52, 58, 91, 0.11);
  margin-bottom: 20px;
  border-radius: 10px;
}

.contain-center .el-col p {
  width: 200px;
  margin: 0 auto;
  line-height: 25px;
}

.contain-center .el-col p:nth-child(2) {
  margin-top: 50px;
  font-size: 20px;
  font-weight: 550;
  color: #18181a;
}

.contain-center .el-col p:nth-child(3) {
  margin-top: 30px;
  font-size: 16px;
  color: #606266;
}

.idea {
  height: 880px;
  padding-top: 10px;
  background: -webkit-linear-gradient(top, #f0f0f4, #ffffff);
}

.idea-contain {
  display: flex;
}

.idea-contain-right {
  width: 470px;
  margin-left: 70px;
  line-height: 40px;
  letter-spacing: 2px;
  color: #18181a;
}

.message {
  width: 214px;
  height: 450px;
}

.message p {
  line-height: 56px;
  color: #252b3a;
  cursor: pointer;
  font-size: 16px;
}

.desc {
  overflow: hidden;
  text-overflow: ellipsis;
  /* white-space: nowrap;
   */
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.message-right {
  background: #e7e9ed;
  width: 100%;
  border-left: none !important;
  border: 1px solid #ebeef5;
}

.activep {
  color: #ffffff !important;
  background: #aa0000;
}

.el-card__body {
  padding: 0px !important;
}

.el-card {
  border-radius: 0px !important;
}

.el-tabs__item {
  margin-top: -10px;
  font-size: 18px !important;
}

.el-button {
  color: #bdbdbd !important;
}

/* .car-vip{
    height: 100%;
    padding-top: 5px;
  } */
.car-vip:hover {
  background: #aa0000 !important;
}

.car-vip:hover p {
  color: #ffffff;
}

.car-vip:hover .el-button {
  background: #aa0000 !important;
  color: #ffffff !important;
  border: 1px solid #ffffff !important;
}

.more-button {
  background: #aa0000;
  width: 100px;
  height: 30px;
  line-height: 30px;
  color: #ffffff;
  margin: 10px auto;
  font-size: 13px;
}
.detail-button{
  color: #aa0000 !important;
  border: 1px solid #aa0000 !important;
}
</style>